import { Toaster } from 'react-hot-toast';
import './App.css';
import Router from './Router';
import 'Styles/commonStyles.scss';
import AutoLogout from 'Components/CommonComponents/AutoLogout';
import * as faceapi from 'face-api.js';
import { useEffect } from 'react';

function App() {
  useEffect(() => {
    const loadModels = async () => {
      await faceapi.nets.ssdMobilenetv1.loadFromUri('/models');
      await faceapi.nets.faceLandmark68Net.loadFromUri('/models');
      await faceapi.nets.faceRecognitionNet.loadFromUri('/models');
    };

    loadModels();
  }, []);
  // const googleTranslateElementInit = () => {
  //   new window.google.translate.TranslateElement(
  //     {
  //       pageLanguage: "en",
  //       autoDisplay: true,
  //     },
  //     "google_translate_element"
  //   );
  // };

  // useEffect(() => {
  //   var addScript = document.createElement("script");
  //   addScript.setAttribute(
  //     "src",
  //     "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
  //   );
  //   document.body.appendChild(addScript);
  //   window.googleTranslateElementInit = googleTranslateElementInit;
  // }, []);

  return (
    <AutoLogout>
      <Router />
      <Toaster position="top-center" reverseOrder={false} />
    </AutoLogout>
  );
}

export default App;
